var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3132_14824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.501 13H3.50098C2.95098 13 2.50098 13.45 2.50098 14V20C2.50098 20.55 2.95098 21 3.50098 21H20.501C21.051 21 21.501 20.55 21.501 20V14C21.501 13.45 21.051 13 20.501 13ZM20.501 3H3.50098C2.95098 3 2.50098 3.45 2.50098 4V10C2.50098 10.55 2.95098 11 3.50098 11H20.501C21.051 11 21.501 10.55 21.501 10V4C21.501 3.45 21.051 3 20.501 3Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3132_14824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda);
export default __webpack_public_path__ + "static/media/agenda.c6aaa3f8f458e3490eadff0aacfdb68e.svg";
export { ForwardRef as ReactComponent };